import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import { ErrorNotice } from '../components/Notice.tsx';
import { rt } from '../lib/runtime.ts';
import { Loading } from './Landing.tsx';

export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    rt().auth.completeSignIn(new URLSearchParams(location.search)).then(() => navigate({ to: '/', replace: true }), setError);
  }, [navigate]);
  return error ? <div className="p-8"><ErrorNotice error={error} /></div> : <Loading />;
}
